module.exports = __webpack_public_path__ + "static/thumb-deliveries-917e53833376db5afffc0bb06e95d750.png";